import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import { DatabaseOutlined } from '@ant-design/icons';
import CarabaoAnimals from "./index";
import ViewCarabao from "./view";
import EditCarabao from "./edit";

const carabaoRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Carabaos",
		basePath: "registered-animals/carabaos",
		mainComponent: <CarabaoAnimals />,
	    layout: "/console",
		icon: <DatabaseOutlined className="h-6 w-6" />,
	    subTitle:"Carabao",
	    viewComponent: <ViewCarabao />,
	    createComponent: <EditCarabao />,
	    editComponent: <EditCarabao />,
	})
]

export default carabaoRoutes;